if (!customElements.get("product-engraving")) {
  class ProductEngraving extends HTMLElement {
    constructor() {
      super();

      this.wrapper = null;
      this.input = null;
      this.charLimitOutput = null;
      this.charLimit = 0;
      this.settingsJson = { optOptionsFormatted: "" };
      this.selectedVariantId = null;
      this.inputName = null;

      this.handleInputBound = this.handleInput.bind(this);
      this.handleVariantChangeBound = this.handleVariantChange.bind(this);
    }

    handleVariantChange(e) {
      if (!e || !e.detail) return;
      const variant = e.detail.variant;
      if (!variant || variant.id === this.selectedVariantId) return;
      this.selectedVariantId = variant.id;
      const yesOptions = this.settingsJson.optOptionsFormatted.split(",");
      const isYesSelected = variant.options.some((option) => yesOptions.includes(option.toLowerCase()));
      this.setVisible(isYesSelected);
      this.renderCharLimit();
    }

    handleInput() {
      let value = this.input.value;

      if (this.charLimit > 0 && value.length >= this.charLimit) {
        value = value.slice(0, this.charLimit);
      }

      this.input.value = value;
      this.renderCharLimit();
    }

    renderCharLimit() {
      if (!this.charLimitOutput || this.charLimit === 0) return;
      const inputValue = this.input.value.trim();
      this.charLimitOutput.innerHTML = `${inputValue.length}/${this.charLimit}`;
    }

    setVisible(isVisible) {
      if (isVisible) {
        this.wrapper.classList.add("input-visible");
        this.input.disabled = false;
        this.input.required = true;
        this.input.name = this.inputName;
        return;
      }

      this.wrapper.classList.remove("input-visible");
      this.input.value = "";
      this.input.name = "";
      this.input.disabled = true;
      this.input.required = false;
    }

    connectedCallback() {
      this.wrapper = this.querySelector(".product-engraving");

      if (!this.wrapper) {
        console.error(".product-engraving not found");
        return;
      }

      const settingsScript = this.querySelector(".product-engraving-json");
      if (!settingsScript) {
        console.error("Settings script not found");
        return;
      }

      this.settingsJson = JSON.parse(settingsScript.innerHTML);

      this.input = this.wrapper.querySelector(".engraving-input");
      this.charLimitOutput = this.wrapper.querySelector(".engraving-limit");

      if (!this.input) {
        console.error("Input not found");
        return;
      }

      this.inputName = this.input.name;
      this.setVisible(this.wrapper.classList.contains("input-visible"));

      if (this.hasAttribute("data-char-limit")) {
        this.charLimit = parseInt(this.getAttribute("data-char-limit"));
      }

      this.renderCharLimit();
      this.handleVariantChange();

      document.addEventListener(`variantChange`, this.handleVariantChangeBound);
      this.input.addEventListener("input", this.handleInputBound);
    }

    disconnectedCallback() {
      document.removeEventListener(`variantChange`, this.handleVariantChangeBound);
      if (this.input) this.input.removeEventListener("input", this.handleInputBound);
    }
  }

  customElements.define("product-engraving", ProductEngraving);
}
